import { Calendar, Clock, MapPin, Users } from "lucide-react";

const WhoShouldApply = () => {
  const criteria = [
    { 
      title: "Event Date", 
      description: "January 31st",
      icon: Calendar 
    },
    { 
      title: "Last Date for Nomination", 
      description: "January 30th",
      icon: Clock
    },
    { 
      title: "Venue", 
      description: "Holiday Inn, Gurugram",
      icon: MapPin
    },
    { 
      title: "Team", 
      description: "Founders committed to scaling and raising",
      icon: Users
    }
  ];

  return (
    <section id="for-startups" className="py-6 px-6 bg-primary text-textPrimary">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Who Should Apply?</h2>
          <p className="text-xl text-textMuted max-w-3xl mx-auto leading-relaxed">
            We welcome Pre-Seed, Angel Funded and Series A startups with a working prototype 
            or early traction. If you're actively raising or preparing to raise, this is for you.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {criteria.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="
                  bg-tertiary 
                  border border-borderLight 
                  p-6 rounded-xl 
                  shadow-card 
                  transition-all
                  group
                  hover:bg-secondary/70 
                  hover:shadow-[0_0_18px_rgba(212,175,55,0.6)]
                  hover:border-[#D4AF37]
                "
              >
                {/* Icon */}
                <div
  className="
    w-14 h-14 
    rounded-xl 
    flex items-center justify-center 
    bg-[linear-gradient(to_right,#22c1c3,#fdbb2d)]
    shadow-[inset_0_0_12px_rgba(255,255,255,0.08)] 
    border border-white/10 
    group-hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] 
    transition-all duration-300
    mb-4
  "
>
  <Icon className="w-7 h-7 text-white group-hover:scale-110 transition-transform" />
</div>

                <div className="font-semibold text-white mb-2">
                  {item.title}
                </div>

                <div className="text-textMuted">
                  {item.description}
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default WhoShouldApply;
